import allImgPaths from 'assets/images'
import CustomSelect from 'components/common/CustomSelect'
import AddCustomBoxModal from 'components/rfp/AddCustomBoxModal'
import React, { useState } from 'react'

const initItems = [
    { text: 'Welcome Message', componentName: 'RfpInnerText', type: 'text', other: {} },
    { text: 'Key Objectives and Highlights ', componentName: 'RfpInnerText', type: 'image', other: {} },
    { text: 'Table of Contents', componentName: 'RfpInnerText', type: 'text', other: {} },
    { text: 'Event Schedule', componentName: 'Schedule', type: 'multi', other: {} },
    { text: 'Speaker Bio', componentName: 'SpeakerBio', type: 'multi', other: {} },
    { text: 'Sponsor', componentName: 'Sponsor', type: 'multi', other: {} },
    { text: 'Social Media', componentName: 'RfpSocialLinks', type: 'link', other: {} },
    { text: 'Call to Action Box', componentName: 'RfpInnerText', type: 'text', other: {} },
    { text: 'Custom', componentName: '', type: 'dynamic' }
]

const EPAddOptions = ({ index, addItem }: any) => {
    const [items, setItems] = useState(initItems)
    const [isShow, setIsShow] = useState(false);
    const [isShowModal, setIsShowModal] = useState(false);

    const handleOption = () => {
        setIsShow(!isShow);
    }

    const handleModal = () => {
        setIsShowModal(!isShowModal);
    }

    const handleClick = (item: any) => {
        if (item.text == 'Custom') handleModal()
        else {
            addItem({ index, ...item })
        }
        setIsShow(false)
    }

    const addCustomBox = (args: any) => {
        const item = {
            text: args.boxTitle || 'No Label',
            componentName: args.componentName,
            type: args.type,
            other: { asAttachment: args.asAttachment, custom: true }
        }
        addItem({ index, ...item })
    }

    return (
        <>
            <div>
                <div className="flex items-center gap-x-2 mb-3 -mt-3 cursor-pointer group">
                    <span className='border-t border-[#D0D5DD] border-dashed w-full opacity-0 group-hover:opacity-100 transition-all duration-300'></span>
                    <div className="relative">
                        <div className="group/inner">
                            <img className='min-w-6 opacity-0 group-hover:opacity-100 transition-all duration-300 on-hover-border-shadow rounded-full' src={allImgPaths.plusCircleBlueIcon} alt="" />
                            <div className={`absolute left-1/2 bottom-full -translate-x-1/2 z-20 bg-white rounded-lg shadow-customShadow8 px-2 py-4 w-80 group-hover/inner:block hidden`}>
                                <ul>
                                    {
                                        items.map((it: any, index: number) => (
                                            <li
                                                key={index}
                                                onClick={() => handleClick(it)}
                                                className='text-sm text-[#475467] mb-6 last:mb-0 px-3 hover:text-[#1E0AF5] font-interMedium'>
                                                {it.text}
                                            </li>
                                        ))
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                    <span className='border-t border-[#D0D5DD] border-dashed w-full opacity-0 group-hover:opacity-100 transition-all duration-300'></span>
                </div>

                <AddCustomBoxModal
                    isShowModal={isShowModal}
                    setIsShowModal={setIsShowModal}
                    addCustomBox={addCustomBox}
                />

                {/* <RfpVendorBoxModal
                    isShowModal={isShowModal}
                    setIsShowModal={setIsShowModal}
                /> */}
            </div>
        </>
    )
}

export default EPAddOptions